import { render, staticRenderFns } from "./CmgCheckoutPaymentIssueModal.vue?vue&type=template&id=87ec8b18&scoped=true&lang=pug"
import script from "./cmg-checkout-payment-issue-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-payment-issue-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutPaymentIssueModal.vue?vue&type=style&index=0&id=87ec8b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ec8b18",
  null
  
)

export default component.exports